import type { SiteData } from '@/data/types';
import siteDataJson from '@/data/site.json';

export function useSiteData() {
  const siteData = siteDataJson as SiteData;
  return { siteData, loading: false, error: null };
}